<div id="sidebar">
    <div class="sidebar-wrapper active">
        <div class="sidebar-header position-relative">
            <div class="d-flex justify-content-between align-items-center">
                <a><img src="images/logo.png" alt="Logo"></a>
                <div class="sidebar-toggler x">
                    <a class="sidebar-hide d-block">
                        <span class="material-symbols-outlined">close</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="sidebar-menu">
            <ul class="menu mb-0">
                <li class="sidebar-title">Menú</li>
                @for (sidebarItem of filteredSidebarItems; track sidebarItem.name) {
                @if (!hasItems(sidebarItem)) {
                <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                    <a class='sidebar-link' [routerLink]="sidebarItem.link">
                        <i class="material-symbols-outlined">
                         {{sidebarItem.icon}}
                        </i>
                        <span class="sidebar-title">{{sidebarItem.name}}</span>
                    </a>
                </li>
                } @else {
                <li class="sidebar-item has-sub">
                    <a class='sidebar-link'>
                        <i class="{{sidebarItem.icon}}"></i>
                        <span>{{sidebarItem.name}}</span>
                    </a>
                    @for (subItem of sidebarItem.subItems; track subItem.name) {
                    <ul class="submenu">
                        <li class="submenu-item">
                            <a [routerLink]="subItem.link" routerLinkActive="active">
                                <span>{{subItem.name}}</span>
                            </a>
                        </li>
                    </ul>
                    }
                </li>
                }
                }
            </ul>
        </div>
    </div>
</div>